/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CalculateResultForOperator
 */
export interface CalculateResultForOperator {
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  onePlusReachPercentage: number;
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  onePlusReachAbsolute: number;
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  gcf: number;
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  grps: number;
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  pricePerGrp: number;
  /**
   *
   * @type {number}
   * @memberof CalculateResultForOperator
   */
  campaignId: number;
}

export function CalculateResultForOperatorFromJSON(
  json: any,
): CalculateResultForOperator {
  return CalculateResultForOperatorFromJSONTyped(json, false);
}

export function CalculateResultForOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateResultForOperator {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    onePlusReachPercentage: json["onePlusReachPercentage"],
    onePlusReachAbsolute: json["onePlusReachAbsolute"],
    gcf: json["gcf"],
    grps: json["grps"],
    pricePerGrp: json["pricePerGrp"],
    campaignId: json["campaignId"],
  };
}

export function CalculateResultForOperatorToJSON(
  value?: CalculateResultForOperator | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    onePlusReachPercentage: value.onePlusReachPercentage,
    onePlusReachAbsolute: value.onePlusReachAbsolute,
    gcf: value.gcf,
    grps: value.grps,
    pricePerGrp: value.pricePerGrp,
    campaignId: value.campaignId,
  };
}
